













import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class ExportarButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
